export default {
    common: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      refresh:'CaseRefresh',
      editPassword: 'EditPassword'
    },
    user:{
      username:'UserName',
      account:'Account'
    },
    header: {
      message: 'this is a common header component'
    },
    footer: {
      message: 'this is a common footer component'
    },
    login: {
      login: 'Next',
      logout: 'Logout'
    },
    menu:{
      home:'Home',
      stock:'Stock',
      userManage: 'User Manager',
      project:'Project List',
      miniProgram: 'MiniProgram',
      merchantsDashboard: 'Merchants Dashboard',
      merchantsRegistrar: 'MERCHANT REGISTRAR',
      businessChances: "Business Chances",
      businessChancesDetail: "Business Chances Detail",
      merchants: 'Merchants',
      merchantSelf: "Merchants Self",
      publicMerchants: "Public Merchants",
      merchantsGroupName: 'Client Manager',
      company:'Company',
      merchantSources: 'Merchant Sources',
      merchantStages: 'Merchant Stages',
      merchantsDetail: "Merchants Detail",
      retention: 'Stock Retention List',
      retentionAdd: 'Add Retention order',
      report:'Project Report',
      error:'404',
      authority:'401'
    }
  }
